export var styleConstants;
(function (styleConstants) {
    styleConstants[styleConstants["inputHeight"] = 56] = "inputHeight";
    styleConstants["borderRadius"] = "1rem";
    styleConstants["buttonPadding"] = ".3em 1em";
    styleConstants["buttonTextTransform"] = "capitalize";
    styleConstants["buttonFontSize"] = "1.125rem";
    styleConstants[styleConstants["buttonFontWeight"] = 300] = "buttonFontWeight";
})(styleConstants || (styleConstants = {}));
